<template>
    <div class="courses1">
        <div class="courses1_cont" id="courses1_cont">
            <div>
                <p class="cn">{{ msg.cname }}</p>
                <p class="en">{{ msg.ename }}</p>
            </div>
        </div>
        <!-- <img :src="url" alt=""> -->
    </div>
</template>
<script>

export default {
    name: "headimg",
    props: {
        url: String,
        msg:Object,
    },
    methods:{
        chanegImg(){
            var courses1_cont = document.getElementById("courses1_cont")
            // console.log(courses1_cont.style.backgroundImage);
            courses1_cont.style.backgroundImage = `url('${this.$props.url}')`
        }
    },
    mounted(){
        this.chanegImg()
       
    },
}
</script>
<style lang="less">
.courses1 {
    width: 1200px;
    height: 360px;
    border: 2px solid #000;
    color: red;
    margin: 50px auto;
    background-color: #fff;
    .courses1_cont {
        width: 1200px;
        height: 360px;
        margin-top: -10px;
        margin-left: -10px;
        border: 2px solid #000;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        background-position: 50%;
        background-size: 100%;
        background-repeat: no-repeat;

        p {
            width: 100%;
            color: #fff;


        }

        .cn {
            font-weight: bold;
            font-size: 66px;
            letter-spacing: 7px;
        }

        .en {
            font-weight: 400;
            font-size: 26px;
            letter-spacing: 3px;
        }
    }
}
</style>